module.exports = __webpack_public_path__ + "img/jiax4.9d751d4f.png";